export default {
    netto: 'Podane ceny są cenami netto'
}
